import n from"styled-components";import{theme as i}from"../../../../../theme.js";const d=n.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px ${i.spacing*4}px ${i.spacing*17}px;
  }
`,o=n.div`
  display: none;
  @media screen and (max-width: ${i.breakpoints.md}) {
    display: block;
  }
`,e=n.div`
  &.mobile {
    display: none;
  }
  &.desktop {
    display: block;
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    &.mobile {
      display: block;
      position: sticky;
      bottom: 0;
      z-index: 10;
    }
    &.desktop {
      display: none;
    }
  }
`;export{e as AddToContainer,o as AdditionalSectionContainer,d as Container};
